import { HostListener, Directive } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[empidCharacters]'
})
export class EmpidCharactersDirective {
    constructor() {}

    @HostListener('keypress', ['$event'])
    onKeyPress(event) {
        return (
            (event.charCode >= 48 && event.charCode <= 57) || // 0-9
            (event.charCode >= 65 && event.charCode <= 90) || // A-Z
            (event.charCode >= 97 && event.charCode <= 122)
        );
    }

    @HostListener('paste', ['$event'])
    onPaste(event) {
        const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return !format.test(event.clipboardData.getData('text'));
    }
}
